// extracted by mini-css-extract-plugin
module.exports = {"TabNavigation":"JobFilter_TabNavigation__B9Z9z"};